import { render, staticRenderFns } from "./WalletRecordDetail.vue?vue&type=template&id=8e7593d0&lang=pug&"
import script from "./WalletRecordDetail.vue?vue&type=script&lang=ts&"
export * from "./WalletRecordDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WalletRecordDetail.vue?vue&type=style&index=0&id=8e7593d0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports